import { ALLOWED_FILE_TYPES } from "./constants";

/**
 * Validate if file types are allowed
 */
export function validateFileTypes(files: FileList): {
	valid: boolean;
	invalidFiles: File[];
} {
	const invalidFiles = Array.from(files).filter(
		(file) => !ALLOWED_FILE_TYPES.includes(file.type as never),
	);

	return {
		valid: invalidFiles.length === 0,
		invalidFiles,
	};
}

/**
 * Convert files to data URLs for preview
 */
export async function convertFilesToDataUrls(
	files: FileList,
): Promise<Array<{ file: File; dataUrl: string }>> {
	const dataUrls: Array<{ file: File; dataUrl: string }> = [];

	for (const file of Array.from(files)) {
		const dataUrl = await new Promise<string>((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = reject;
			reader.readAsDataURL(file);
		});

		dataUrls.push({ file, dataUrl });
	}

	return dataUrls;
}

/**
 * Remove file from FileList by index
 */
export function removeFileFromFileList(
	files: FileList,
	index: number,
): FileList | undefined {
	const fileArray = Array.from(files);
	fileArray.splice(index, 1);

	if (fileArray.length === 0) {
		return undefined;
	}

	// Create new FileList using DataTransfer
	const dataTransfer = new DataTransfer();
	for (const file of fileArray) {
		dataTransfer.items.add(file);
	}

	return dataTransfer.files;
}

/**
 * Detect if text contains RTL characters (Hebrew, Arabic)
 */
export function isRTLText(text: string): boolean {
	const rtlRegex = /[\u0590-\u05FF\u0600-\u06FF]/;
	return rtlRegex.test(text);
}
